import { createSlice } from '@reduxjs/toolkit';

const savedAuthState = typeof window !== 'undefined' ? localStorage.getItem('authState') : null;
const initialState = savedAuthState
  ? JSON.parse(savedAuthState)
  : {
      currentUser: null,
      selectedProject: null,
      isAuthenticated: false,
    };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action) {
      state.currentUser = action.payload;
      state.isAuthenticated = true;
    },
    clearUser(state) {
      state.currentUser = null;
      state.isAuthenticated = false;
      state.selectedProject = null;
    },
    setProject(state, action) {
      state.selectedProject = action.payload;
    },
  },
});

export const { setUser, clearUser, setProject } = authSlice.actions;
export default authSlice.reducer;
